import log from './log'
import { SEX } from '@/consts'
export * from './qrcode'
//getrand
export function rand (max) {
  return Math.floor(Math.random() * max)
}
//getRandwords 获取随机字符串
export function getRandwords (ls = 8) {
  var chars = ''
  var passwords = []
  var passwordUnique = true
  var quantity = 1
  chars += '0123456789'
  chars += 'abcdefghijklmnopqrstuvwxyz'
  chars += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  while (passwords.length < quantity) {
    var _chars = chars.split('')
    var password = ''
    for (var i = 0, l = ls; i < l; i++) {
      if (_chars.length < 1) break

      var idx = rand(_chars.length)
      password += _chars[idx]
      if (passwordUnique) _chars.splice(idx, 1)
    }
    if (passwords.indexOf(password) === -1) passwords.push(password)
  }
  return passwords.join('\n')
}

export function importAll (r, fn = (key, r) => r(key)) {
  r.keys().forEach((key) => fn(key, r))
}

export function getUrlRelativePath (url) {
  var arrUrl = url.split('//')

  var start = arrUrl[1].indexOf('/')
  var relUrl = arrUrl[1].substring(start)

  if (relUrl.indexOf('?') !== -1) {
    relUrl = relUrl.split('?')[0]
  }
  return relUrl
}

export function formatSex (sex) {
  if (sex == SEX.MEN) return '男'
  if (sex == SEX.WOMEN) return '女'
  return '未知'
}
//判断当前环境是否为企微环境
export function isWeiXin () {
  const ua = window.navigator.userAgent.toLowerCase()
  // console.log('ua',ua)
  // console.log('ua.match(/MicroMessenger/i)',ua.match(/MicroMessenger/i)[0])
  if (!ua.match(/MicroMessenger/i)) return false
  if (ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
    return true
  }
  return false
}
export function formatMenu (item) {
  if (!item.name) {
    item.name = item.menu_name
  }
  if (!item.id) {
    item.id = item.menu_id
  }
  if (!item.pid) {
    item.pid = item.menu_pid
  }
}

export function filterHideMenu (menu) {
  return menu.filter((item) => {
    if (item.children && item.is_show != 0) {
      return {
        ...item,
        children: filterHideMenu(item.children)
      }
    }
    return item.is_show != 0
  })
}

export function collectTreeId (arr, ids = []) {
  arr.forEach(({ id, children }) => {
    if (id) {
      ids.push(id)
    }
    if (children) {
      collectTreeId(children, ids)
    }
  })
  return ids
}

export { log }
